import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Scales, SignOut, Gear, House, ChartBar, UserCircle, Envelope } from '@phosphor-icons/react';

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isAdmin = user?.role === 'admin';

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <header className="sticky top-0 z-50 bg-white border-b border-[#E5E7EB]" data-testid="app-header">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 flex items-center justify-between h-14">
          <Link to="/dashboard" className="flex items-center gap-2 hover:opacity-80 transition-opacity" data-testid="logo-link">
            <Scales weight="duotone" className="w-6 h-6 text-[#002FA7]" />
            <span className="font-outfit text-lg font-bold text-[#09090B]">ClarityCase AI</span>
          </Link>
          <nav className="flex items-center gap-1">
            <Link to="/dashboard" data-testid="nav-dashboard"
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-ibm transition-all ${location.pathname === '/dashboard' ? 'bg-[#002FA7]/10 text-[#002FA7] font-semibold' : 'text-[#6B7280] hover:bg-[#F3F4F6] hover:text-[#09090B]'}`}>
              <House size={16} /> Cases
            </Link>
            <Link to="/inbox" data-testid="nav-inbox"
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-ibm transition-all ${location.pathname === '/inbox' ? 'bg-[#002FA7]/10 text-[#002FA7] font-semibold' : 'text-[#6B7280] hover:bg-[#F3F4F6] hover:text-[#09090B]'}`}>
              <Envelope size={16} /> Inbox
            </Link>
            {isAdmin && (
              <Link to="/admin" data-testid="nav-admin"
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-ibm transition-all ${location.pathname === '/admin' ? 'bg-[#002FA7]/10 text-[#002FA7] font-semibold' : 'text-[#6B7280] hover:bg-[#F3F4F6] hover:text-[#09090B]'}`}>
                <ChartBar size={16} /> Admin
              </Link>
            )}
            <Link to="/billing" data-testid="nav-billing"
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-ibm transition-all ${location.pathname === '/billing' ? 'bg-[#002FA7]/10 text-[#002FA7] font-semibold' : 'text-[#6B7280] hover:bg-[#F3F4F6] hover:text-[#09090B]'}`}>
              <Gear size={16} /> Billing
            </Link>
            <Link to="/settings" data-testid="nav-settings"
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-ibm transition-all ${location.pathname === '/settings' ? 'bg-[#002FA7]/10 text-[#002FA7] font-semibold' : 'text-[#6B7280] hover:bg-[#F3F4F6] hover:text-[#09090B]'}`}>
              <UserCircle size={16} /> Account
            </Link>
          </nav>
          <div className="flex items-center gap-3">
            <span className="text-sm text-[#6B7280] font-ibm hidden sm:inline">{user?.name || user?.email}</span>
            <button data-testid="logout-button" onClick={handleLogout}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-[#6B7280] hover:text-[#09090B] hover:bg-[#F3F4F6] rounded-md font-ibm transition-all">
              <SignOut size={16} /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
